// import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { MenuContext } from '../../Context/Menucontext'
import ContactPop from "../../Pages/Contactpop/Contactpop";
import "./Tubboatdetails.css";

const TugboatDeatails = () => {
  const {ispopUp, setIspopUp} = useContext(MenuContext);
  // const {id} = useParams()
  const navigate = useNavigate();
  return (
    <div className="tug-detials-container">
      {
            ispopUp && <ContactPop/>
          }
      <div className="wrapper">
        <div className="tug-detials-header"></div>
        <div className="tug-detials-nav">
          <i className="fa-solid fa-house"></i>
          <Link to="/Charttering">
            <i className="fa-solid fa-greater-than"></i> Charttering
          </Link>
          <Link to="/Charttering">
            <i className="fa-solid fa-greater-than"></i> Vessel Categories
          </Link>
          <Link to="/Tugboat">
            <i className="fa-solid fa-greater-than"></i> Tug Boats
          </Link>
          <Link to="/">
            <i className="fa-solid fa-greater-than"></i> ASD Tug Navigator
          </Link>
          <button onClick={() => navigate("/Tugboat")}>
            {" "}
            <i className="fa-solid fa-less-than"></i> Back to Tug Boats
          </button>
        </div>
      </div>
      <div className="tug-details-banner">
        <div className="head">
          <h3>ASG Tug Navigator</h3>
          <span>
            <p>$2000/Day</p>
            <button onClick={() => setIspopUp(true)}>Contact</button>
          </span>
        </div>
        <div className="sgs-certify">
          <div className="inner">
            <span>
              <p>Call sign</p>
              <h3>SORO1</h3>
            </span>
            <span>
              <p>IMO</p>
              <h3>8811651</h3>
            </span>
            <span>
              <p>MMSI</p>
              <h3>657214200</h3>
            </span>
            <span>
              <p>DWT (t)</p>
              <h3>70.0</h3>
            </span>
          </div>
          <span>
            <p>sgs certified:</p>
            <h3>Yes</h3>
          </span>
          <p>
            The Navigator (ASD 2312) delivers a powerful 70 tonnes of bollard
            pull while the patented Twin Fin skeg plus twin Azimuth thrusters
            ensure excellent manoeuvrability. An obstacle-free working deck
            ensures a safe working environment for the six crew members, as does
            the powerful covered winch which handles both forward and aft
            operations. The Navigator is outfitted with: FiFi 1, Winterization
            package and is IMO Tier III certified.
          </p>
          <div className="inner">
            <span>
              <h3>SPeed</h3>
              <p>13.0 (kn)</p>
            </span>
            <span>
              <h3>Bollard Pull</h3>
              <p>70.0 (t)</p>
            </span>
            <span>
              <h3>Length</h3>
              <p>22.60 (m)</p>
            </span>
            <span>
              <h3>Width</h3>
              <p>120 (m)</p>
            </span>
          </div>
          <div className="line"></div>
        </div>
        <div className="specs">
          <h3>Specifications</h3>
          <div className="wrapper">
            <div className="box">
              <span>
                <p>Bollard Pull</p>
                <h3>Bollard Pull</h3>
              </span>
              <span>
                <p>Classification</p>
                <h3>
                  Bureau Veritas I ✠ HULL ● MACH Escort Tug (Bollard pull = 70
                  t, maximum steering force = 65 t, maximum braking force = 49
                  t, maximum escort speed = 10 kn) Unrestricted Navigation AUT
                  UMS Inwater Survey Fire Fighting Ship 1 Green Passport EU
                </h3>
              </span>
              <span>
                <p>Flag</p>
                <h3>The Netherlands</h3>
              </span>
              <span>
                <p>Beam overall</p>
                <h3>12.03 m</h3>
              </span>
              <span>
                <p>Draught</p>
                <h3>5.40 m</h3>
              </span>
              <span>
                <p>Deckspace</p>
                <h3>n/a</h3>
              </span>
              <span>
                <p>Displacement</p>
                <h3>485 t</h3>
              </span>
            </div>
            <div className="box">
              <span>
                <p>Fuel oil</p>
                <h3>54,6 m³</h3>
              </span>
              <span>
                <p>Fresh water</p>
                <h3>7.8 m³</h3>
              </span>
              <span>
                <p>Main engines</p>
                <h3>2x Caterpillar 3512C TA HD/D</h3>
              </span>
              <span>
                <p>Total power</p>
                <h3>3804 bkW (5102 bhp) at 1800 rpm</h3>
              </span>
              <span>
                <p>Propulsion</p>
                <h3>
                  Clutches (on-off type): Kongsberg Maritime ‘built in’ type or
                  equal Azimuth thrusters: Kongsberg Maritime US 205 Propeller
                  diameter: 2800 mm
                </h3>
              </span>
              <span>
                <p>Genset</p>
                <h3>2x Caterpillar C4.4 TA, 400 V, 103 kVA, 50 Hz</h3>
              </span>

              <span>
                <p>Deck equipment</p>
                <h3>
                  Anchors: 2x 360 kg Pool (High Holding Power) Anchor winches:
                  10 m/min Towing winch: Hydraulically driven double drum, pull
                  up to 35 ton and speed up to 40 m/min on second layer, 175 ton
                  brake holding force Fendering: D-fender at sides, cylindrical
                  fender at transom corners, cylindrical and W-block bow fender
                </h3>
              </span>
              <span>
                <p>Nautical equipment</p>
                <h3>
                  Searchlights: 2x Norselight SH470 2000 W Radar system: Furuno
                  FAR 1518-BB ECDIS: Furuno FMD-3200 Compass: Cassens & Plath
                  Reflecta 11 Satellite compass/GPS: Simrad GN70/HS80A
                  Autopilot: Simrad AP-70
                </h3>
              </span>
              <span>
                <p>Accommodation</p>
                <h3>For 6 persons (MLC 2006 compliant)</h3>
              </span>
            </div>
          </div>
          <div className="line"></div>
          <div className="survey">
            <h3>Survey</h3>
            <div className="survey-card">
              <div className="box">
                <p>International Anti-Fouling System</p>
                <div className="inner">
                  <span>
                    <p>Issue Date:</p>
                    <h3>10 Jun 2022</h3>
                  </span>
                  <span>
                    <p>Exp Date:</p>
                    <h3>--</h3>
                  </span>
                  <span>
                    <p>Issue By:</p>
                    <h3>NIMASA</h3>
                  </span>
                  <span>
                    <p>Inspected Date:</p>
                    <h3>18 Aug 2022</h3>
                  </span>
                </div>
              </div>
              <div className="box">
              <p>International Anti-Fouling System</p>
                <div className="inner">
                  <span>
                    <p>Issue Date:</p>
                    <h3>10 Jun 2022</h3>
                  </span>
                  <span>
                    <p>Exp Date:</p>
                    <h3>--</h3>
                  </span>
                  <span>
                    <p>Issue By:</p>
                    <h3>NIMASA</h3>
                  </span>
                  <span>
                    <p>Inspected Date:</p>
                    <h3>18 Aug 2022</h3>
                  </span>
                </div>
              </div>
              <div className="box">
              <p>International Anti-Fouling System</p>
                <div className="inner">
                  <span>
                    <p>Issue Date:</p>
                    <h3>10 Jun 2022</h3>
                  </span>
                  <span>
                    <p>Exp Date:</p>
                    <h3>--</h3>
                  </span>
                  <span>
                    <p>Issue By:</p>
                    <h3>NIMASA</h3>
                  </span>
                  <span>
                    <p>Inspected Date:</p>
                    <h3>18 Aug 2022</h3>
                  </span>
                </div>
              </div>
            </div>
            <div className="line"></div>
            <div className="gallery">
              <h3>Gallery</h3>
             <div className="inner">
             <div className="card"></div>
              <div className="card"></div>
              <div className="card"></div>
              <div className="card"></div>
              <div className="card"></div>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TugboatDeatails;
